export const VIEWS = {
  MobileNav: 'MobileNav',
  MobileSubNav: 'MobileSubNav',
  MobileSubscription: 'MobileSubscription'
}
